<template>
  <!-- eslint-disable-next-line vuejs-accessibility/alt-text | Component has been added to the plugin allowlist so parent components that implement must add alt tag -->
  <img :src="src" />
</template>

<script>
/* eslint-disable vue/component-api-style */
import { logAndNotify } from 'utils/log_and_notify'

export default {
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return { src: null }
  },
  watch: {
    path: {
      immediate: true,
      handler(path) {
        this.loadImage(path)
      },
    },
  },
  methods: {
    loadImage(path) {
      this.src = null
      import(
        /* webpackMode: "eager" */
        /* webpackExclude: /\.svg$/ */
        `images/${path}`
      )
        .then(({ default: src }) => {
          if (this.path === path) this.src = src
        })
        .catch(logAndNotify)
    },
  },
}
</script>
